/**
 * Product-wide tagline — matches the signed-in loop: Notebook hub (import / generate Q&A)
 * → Library (search & read) → Study hub (save, practice, spaced review).
 */
export const QNAREAD = {
  name: 'QnaRead',
  tagline: 'Knowledge That Stays With You.',
  taglineShort: 'Knowledge that stays with you',
};

/** User-facing name for the signed-in overview at `/dashboard` (not the question Library at `/library`). */
export const STUDY_HUB = {
  name: 'Study hub',
  /** Top nav label (dashboard / overview at `/dashboard`) */
  navLabel: 'Home',
  shortNavLabel: 'Home',
  path: '/dashboard',
  tagline: 'What’s due, what’s next, and how close you are—before the exam is.',
  flowSteps: ['Discover', 'Read', 'Save', 'Practice', 'Review'],
};

export const LIBRARY = {
  name: 'Library',
  path: '/library',
};

/** Q&A hub: import, PDFs, generated Q&A (`/hub`). */
export const LEARN_HUB = {
  name: 'Hub',
  /** Shown in the top nav next to Study hub */
  navLabel: 'Hub',
  shortNavLabel: 'Hub',
  eyebrow: 'Q&A hub',
  path: '/hub',
  summary: 'Q&A & PDFs',
  tagline: 'Spin up Q&A from PDFs and links—AI builds the cards, Study hub makes it stick.',
  purpose: 'Create Q&A sets, import PDFs or URLs, study — then Review on Study hub.',
};
